import QuinielasDashboard from './QuinielasDashboard';
export default QuinielasDashboard;
